import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsSchemasRoute: InvariantJiraRoute = {
	name: 'assets',
	path: '/jira/assets/schemas',
	exact: true,
};
